define('sections/users/Podio.UI.Signup.SSO',['require','jquery','lib/Podio.Timezone','lib/Podio.SingleSignOn','lib/Podio.Event.UI','lib/Podio.Event','sections/users/Podio.UI.Signup.SSO'],function(require) {

  var $ = require('jquery');
  var podioTimezone = require('lib/Podio.Timezone');
  var singleSignOn = require('lib/Podio.SingleSignOn');
  var eventUI = require('lib/Podio.Event.UI');
  var podioEvent = require('lib/Podio.Event');

  var providerMap = {
    citrix: {
      width: 980,
      height: 650,
      trackingName: 'Citrix'
    },
    live: {
      width: 950,
      height: 475,
      trackingName: 'Live'
    },
    google: {
      width: 700,
      height: 475,
      trackingName: 'GAppsConnect'
    },
    sharefile: {
      width: 950,
      height: 475,
      trackingName: 'Sharefile'
    },
    sharefile_limited: {
      width: 950,
      height: 475,
      trackingName: 'SharefileLimited'
    }
  };

  function onConnectFomSubmitted(elmTarget, e) {
    var provider = elmTarget.data('provider');

    var url = elmTarget.attr('action');
    url += '?' + elmTarget.serialize();

    singleSignOn.popup(url, providerMap[provider].width, providerMap[provider].height);
  }
  function onConnectFormIphoneSubmitted(elmTarget, e) {
    var provider = elmTarget.data('provider');
  }

  function onInit() {
    if (podioTimezone) {
      var elmForms = $('.sso-form');
      elmForms.each(function() {
        var elmTimezoneField = $(this).find('input[name=timezone]');
        if (elmTimezoneField.length) {
          var timezone = podioTimezone.detectTimeZone().olson_tz;
          elmTimezoneField.val(timezone);
        }
      });
    }

    singleSignOn.signals.onOAuthComplete.add(onOAuthComplete);
  }

  function onOAuthComplete(data) {
    if (data.state === 'contact' || data.state === 'invite' || data.state === 'signin' || data.state === 'signup') {
      var signupSSO = require('sections/users/Podio.UI.Signup.SSO');

      window.location.href = data.redirect_url;
      window.focus();

    }
  }

  podioEvent.bind(podioEvent.Types.init, onInit);
  eventUI.bind('submit', '.sso-form', onConnectFomSubmitted);
  eventUI.bind('submit', '.sso-form.iphone', onConnectFormIphoneSubmitted, true);

});

